module.exports = __webpack_public_path__ + "static/media/map.d4a9a0b3.svg";